module.exports = __webpack_public_path__ + "static/media/ani.136b0c1d.gif";